import { render, staticRenderFns } from "./WorldSky.vue?vue&type=template&id=3952dcb8&scoped=true&"
import script from "./WorldSky.vue?vue&type=script&lang=js&"
export * from "./WorldSky.vue?vue&type=script&lang=js&"
import style0 from "./WorldSky.vue?vue&type=style&index=0&id=3952dcb8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3952dcb8",
  null
  
)

export default component.exports